import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ProjectSettingsStore, FloorPlanSettings } from '../../../stores/ProjectSettingsStore';
import { FloorPlanActions } from '../../../actions/FloorPlanActions';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { PopupMenu } from '../../../constants/Enums';
import { UICoreRangeSlider } from '../../UICoreRangeSlider';

interface FloorPlanSetupProps {
    layoutType: LayoutType;
}

interface FloorPlanSetupState {
    colorReduction: number;
    visibility: number;
    brightness: number;
}

export class FloorPlanSetup extends BaseComponent<FloorPlanSetupProps, FloorPlanSetupState> {
    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div className="floorplan-setup">
                <div className="egr-select-option-header">
                    <span>{t('Floor Plan')}</span>
                    <div className="floorplan-setup-upload sprite-icon-upload" onClick={this.chooseImage}/>
                    <div className="floorplan-setup-close sprite-icon-close" onClick={this.closePopup}/>
                </div>
                <div className="floorplan-setup-content">
                    <UICoreRangeSlider
                        label={t('Opacity')}
                        onChange={this.visibility}
                        initialValue={this.state.visibility * 100}
                        min={0}
                        max={100}
                        areaTolerance={30}
                    />
                    <UICoreRangeSlider
                        label={t('Contrast')}
                        onChange={this.colorReduction}
                        initialValue={this.state.colorReduction * 100}
                        min={0}
                        max={100}
                        areaTolerance={30}
                    />
                    <UICoreRangeSlider
                        label={t('Brightness')}
                        onChange={this.brightness}
                        initialValue={this.state.brightness * 100}
                        min={0}
                        max={100}
                        areaTolerance={30}
                    />
                </div>
            </div>
        );
    }

    protected closePopup = () => {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
    };

    protected chooseImage = () => {
        VisibilityActions.hidePopupMenu(PopupMenu.FLOORPLAN_SETUP);
        FloorPlanActions.getImageFile();
    };

    protected onChange = () => {
        const settings: FloorPlanSettings | null = ProjectSettingsStore.getState().floorPlan;
        this.setState({
            colorReduction: (settings != null && settings.colorReduction != null) ? settings.colorReduction : 0,
            visibility: (settings != null && settings.opacity != null) ? settings.opacity : 0,
            brightness: (settings != null && settings.brightness != null) ? settings.brightness : 0
        });
    };

    protected colorReduction(value: number): void {
        FloorPlanActions.setColorReduction(value / 100);
    }

    protected visibility(value: number): void {
        FloorPlanActions.setVisibility(value / 100);
    }

    protected brightness(value: number): void {
        FloorPlanActions.setBrightness(value / 100);
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/floorplan/FloorPlanSetup.tsx